import { render } from "./Asistencia.vue?vue&type=template&id=9acc9bf4"
import script from "./Asistencia.vue?vue&type=script&lang=js"
export * from "./Asistencia.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice-base-vue3/backoffice-base-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__